var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{staticClass:"vz-loading-spinner",attrs:{"active":_vm.active}})
}
var staticRenderFns = []

export { render, staticRenderFns }